import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {MatTableModule} from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatListModule} from '@angular/material/list';
import {MatRippleModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';
import {MatBadgeModule} from '@angular/material/badge';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatStepperModule} from '@angular/material/stepper';
import {MatRadioModule} from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { NgModule } from '@angular/core';

@NgModule({
  imports: [MatCheckboxModule,MatDatepickerModule,MatSlideToggleModule,MatSortModule,MatRadioModule,MatStepperModule,MatProgressSpinnerModule,MatBadgeModule,MatTabsModule,MatTooltipModule,MatRippleModule,MatListModule,MatSelectModule,MatPaginatorModule,MatTableModule,MatDividerModule,MatMenuModule,MatButtonModule, MatButtonToggleModule, MatProgressBarModule, MatChipsModule, MatExpansionModule, MatIconModule, MatFormFieldModule, MatInputModule, MatCardModule],
  exports: [MatCheckboxModule,MatDatepickerModule,MatSlideToggleModule,MatSortModule,MatRadioModule,MatStepperModule,MatProgressSpinnerModule,MatBadgeModule,MatTabsModule,MatTooltipModule,MatRippleModule,MatListModule,MatSelectModule,MatPaginatorModule,MatTableModule,MatDividerModule,MatMenuModule,MatButtonModule, MatButtonToggleModule, MatProgressBarModule, MatChipsModule, MatExpansionModule, MatIconModule, MatFormFieldModule, MatInputModule, MatCardModule]
})

export class MaterialModule { }
